module.exports = __webpack_public_path__ + "static/media/05_good_01.d8e7ad7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-3/05_good_01.png
// module id = 702
// module chunks = 0